import { arrayToggle } from '../Option';
import Util from '../../../../Common/Util';

export default class OptionLadder {
    constructor() {
    }
    getHtml = function(){
        return `
<div class="ladder_car">
    <div class="flex">
        <div class="left flex_column">
            <h2>층수선택</h2>
            <div class="floors_number ladder-floor">
                <div class="flex floor" data-index="5" data-range="1~2">2층 (5m)</div>
                <div class="flex floor" data-index="8" data-range="1~3">3층 (8m)</div>
                <div class="flex floor" data-index="11" data-range="1~4">4층 (11m)</div>
                <div class="flex floor" data-index="14" data-range="1~5">5층 (14m)</div>
                <div class="flex floor" data-index="17" data-range="1~5">6층 (17m)</div>
                <div class="flex floor" data-index="20" data-range="1~5">7층 (20m)</div>
                <div class="flex floor" data-index="23" data-range="1~5">8층 (23m)</div>
                <div class="flex floor" data-index="26" data-range="1~5">9층 (26m)</div>
                <div class="flex floor" data-index="28" data-range="1~6">10층 (28m)</div>
                <div class="flex floor" data-index="30" data-range="3~6">11층 (30m)</div>
                <div class="flex floor" data-index="33" data-range="3~6">12층 (33m)</div>
                <div class="flex floor" data-index="36" data-range="3~6">13층 (36m)</div>
                <div class="flex floor" data-index="38" data-range="4~6">14층 (38m)</div>
                <div class="flex floor" data-index="41" data-range="4~6">15층 (41m)</div>
                <div class="flex floor" data-index="44" data-range="4~6">16층 (44m)</div>
                <div class="flex floor" data-index="46" data-range="5~6">17층 (46m)</div>
                <div class="flex floor" data-index="48" data-range="5~6">18층 (48m)</div>
                <div class="flex floor" data-index="51" data-range="6">19층 (51m)</div>
                <div class="flex floor" data-index="54" data-range="6">20층 (54m)</div>
                <div class="flex floor" data-index="56" data-range="6">21층 (56m)</div>
                <div class="flex floor" data-index="58" data-range="6">22층 (58m)</div>
                <div class="flex floor" data-index="61" data-range="6">23층 (61m)</div>
                <div class="flex floor" data-index="64" data-range="6">24층 (64m)</div>
                <div class="flex floor" data-index="65" data-range="6">25층 (65m)</div>
            </div>
        </div>
        <div class="right flex_column ladder-tons">
            <h2>장비 톤수선택</h2>
            <div class="item flex off" data-index="1" data-code="200">1톤</div>
            <div class="item flex off" data-index="2" data-code="210">1.4톤</div>
            <div class="item flex off" data-index="3" data-code="220">2.5톤</div>
            <div class="item flex off" data-index="4" data-code="230">3.5톤</div>
            <div class="item flex off" data-index="5" data-code="240">4.5톤</div>
            <div class="item flex off" data-index="6" data-code="250">5톤</div>
        </div>
    </div>
    <h2 class="title1">옵션선택</h2>
    <div class="option flex_column">
        <div class="division_3 flex">
            <select class="select-box flex_space_around" data-value="전고">
                <option value="">전고</option>
            </select>
            <select class="select-box flex_space_around" data-value="짐짜주기" data-code="230">
                <option value="">짐짜주기없음</option>
                <option value="상차">상차</option>
                <option value="하차">하차</option>
                <option value="상하차">상하차</option>
            </select>
            <select class="select-box flex_space_around" data-value="이동거리" data-code="240">
                <option value="">이동거리</option>
                <option value="관내">관내</option>
                <option value="관외">관외</option>
            </select>
        </div>
        <div class="division_3 flex">
            <div class="item flex" data-value="덤프" data-code="200">
                덤프
            </div>
            <div class="item flex op0"></div>
            <div class="item flex op0"></div>
        </div>
    </div>
    <div class="car-example"></div>
    <div class="blank"></div>
    <div class="button flex">
        <div class="button_yellow flex apply-data">완료</div>
    </div>
</div>`;
    }
    /**
     * 화면 초기화
     * @param parent OptionWindow 인스턴스
     */
    init = function(parent) {
        this.parent=parent;
        console.log('window.option.ladder.init');
        this.load(); // 변수 초기화
        this.parent.drawJungo();// 전고 그리기 ( 최초한번만 )
        this.draw();

        this.initFloorHandler();// 층수 클릭시
        this.initTonHandler();// 톤 클릭시
        this.parent.initOptionHandler();// 옵션버튼 클릭시
        this.parent.initApplyHandler(function(optWin){// 완료버튼 클릭시
            const floor = optWin.mainIdx;
            const tons = optWin.subIdxList;
            if( !floor){
                Util.swalert('층수를 선택해주세요.');
                return false;
            }
            if( tons.length==0 ) {
                Util.swalert('톤수를 선택해주세요.');
                return false;
            }
            return true;

        });
    }
    /**
     * 변수 초기화
     */
    load = function(){
        const self = this;
        const data = this.parent.data;
        const car_range = data['car_range'];
        if(!car_range) return;

        const arr = car_range.split('|');
        const tons = arr[0].split(',');
        const meter = arr[1].replace('~','');
        this.parent.mainIdx = meter;
        // 층수 순회
        $('#'+this.parent.id+' .ladder-floor .floor').each(function(){
            const idx = $(this).attr('data-index');
            if( idx!=meter) return;
            const range = $(this).attr('data-range');
            self.parent.subIdxRangeLimit=range.split('~');
        });
        // 톤수 순회
        $('#'+this.parent.id+" .ladder-tons .item").each(function(){
            const idx = $(this).attr('data-index');
            const code = $(this).attr('data-code');
            if( tons.includes(code)){
                self.parent.subIdxList.push(idx);
            }
        });
    }
    /**
     * 층수 선택 핸들러
     */
    initFloorHandler = function(){
        const self = this;
        // 층수 순회
        $('#'+this.parent.id+' .ladder-floor .floor').off().on('click',function(){
            self.parent.mainIdx = $(this).attr('data-index');// 미터수
            const r = $(this).attr('data-range');// 톤수인덱스범위
            const arr =r.split('~');
            self.parent.subIdxRangeLimit = arr;
            let fr = Util.int(arr[0]);
            let to = fr;
            if( arr[1] ){
                to = Util.int(arr[1]);
            }
            self.parent.subIdxList=[];
            // 톤수 버튼 순회
            $('#'+self.parent.id+' .ladder-tons .item').each(function(){
                const idx = Util.int($(this).attr('data-index'));
                if( fr<=idx && idx<=to ){
                    self.parent.subIdxList.push( $(this).attr('data-index'));
                }
            });

            self.updateRange();
            self.parent.calcPrice();
            self.draw();
            self.parent.showDebug();
        });
    }
    /**
     * 사다리 톤수 선택 핸들러
     */
    initTonHandler = function(){
        const self = this;
        $('#'+self.parent.id+' .ladder-tons .item').off().on('click',function(){
            const arr = self.parent.subIdxRangeLimit;// 톤수의 최대범위
            if( arr.length==0) {
                Util.swalert('층수를 먼저 선택하세요');
                return;
            }
            const fr = arr[0];
            const to = arr[1];
            // const tons = self.parent.subIdxList;// 톤수목록

            const idx = $(this).attr('data-index');
            // console.log(idx, fr, to);
            if( idx<fr || to<idx) return; // 가용범위 밖이면 스킵


            // 톤수목록 토글
            self.parent.subIdxList = arrayToggle(self.parent.subIdxList,idx);
            // if( tons.includes(idx) ){
            //     tons.splice(tons.indexOf(idx),1);
            // }else{
            //     tons.push(idx);
            // }

            self.updateRange();
            self.parent.calcPrice();
            self.draw();
            self.parent.showDebug();
        });
    }

    /**
     * car_range 값을 업데이트한다.
     */
    updateRange = function(){
        // car_range => 200,210,220,230|11~
        const self = this;
        const data = this.parent.data;
        const meter = this.parent.mainIdx;

        // 톤버튼 순회
        const codeList = [];
        $('#'+this.parent.id+" .ladder-tons .item").each(function() {
            const idx = $(this).attr('data-index');
            const code = $(this).attr('data-code');
            if( self.parent.subIdxList.includes(idx)){
                codeList.push(code);
            }
        });

        data['car_range'] = codeList.join(',')+`|${meter}~`;
    }
    draw = function(){
        this.drawRange();
        this.parent.drawOptions();
    }
    /**
     * 화면 업데이트
     * @param data
     */
    drawRange = function(){
        const self = this;
        let floor = self.parent.mainIdx;
        let tons = self.parent.subIdxList;
        const arr = self.parent.subIdxRangeLimit;// 톤수의 최대범위
        let fr=0;
        let to=0;
        if( arr.length>0 ) {
            fr = arr[0];
            to = arr[1];
        }

        // 층 그리기
        $('#'+this.parent.id+" .ladder-floor .floor").each(function(){
            if( $(this).attr('data-index')==floor ) $(this).addClass('on');
            else $(this).removeClass('on');
        });

        // 톤 버튼 그리기
        $('#'+this.parent.id+" .ladder-tons .item").each(function(){
            const idx = $(this).attr('data-index');
            // console.log(idx);
            if( tons.includes(idx) ) {
                $(this).removeClass('off').addClass('on');
            }
            else {
                $(this).removeClass('on');
                if( fr<=idx && idx<=to){
                    $(this).removeClass('off');
                }else{
                    $(this).addClass('off');
                }
            }
        });

    }
}
